import React from 'react';
import { Layout } from 'antd';

const { Footer: AntdFooter } = Layout;

const Footer: React.FC = () => {
  return (
    <AntdFooter className="admin-footer">
      ©{new Date().getFullYear()} Created by DYENites for DYEN
    </AntdFooter>
  );
};

export default Footer;
